export const WORDS = [
  'boots',
  'byron',
  'tesco',
  'plough',
  'CEDAR',
  'BAKER',
  'POETS',
  'MAPLE',
  'nabbs',
  'yellow',
  'south',
  'dorey',
  'plumb',
  'allen',
  'delia',
  'keats',
  'glebe',
  'ascot',
  'tudor',
  'north',
  'dukes',
  'sandy',
  'covid',
  'sucks',
  'plane',
  'green',
  'larch',
  'ellis',
  'story',
  'piper',
  'maori',
  'crown',
  'brook',
  'forge',
  'latin',
  'susan',
  'poppy',
  'rydal',
  'hazel',
  'belle',
  'trent',
  'coupe',
  'queen',
  'knoll',
  'linby',
  'briar',
  'munks',
  'magee',
  'lacey',
  'baths',
  'thorn',
  'marie',
  'lilac',
  'nixon',
  'croft',
  'brett',
  'DRURY',
  'ABBOTS',
  'ACACIA',
  'AERIAL',
  'ALBANY',
  'ALBERT',
  'ALISON',
  'ALMOND',
  'ANNIES',
  'ASHLEY',
  'ASTRAL',
  'AVOCET',
  'BADGER',
  'BAMKIN',
  'BARKER',
  'BEACON',
  'BETHEL',
  'BODILL',
  'BODMIN',
  'BRIDGE',
  'CADDAW',
  'CAVELL',
  'CHAPEL',
  'CHERRY',
  'CHEYNE',
  'CHURCH',
  'COATES',
  'COMMON',
  'CONWAY',
  'COVERT',
  'CURTIS',
  'DEVITT',
  'EDMOND',
  'EDWARD',
  'FALCON',
  'FELLEY',
  'FLYING',
  'FOREST',
  'GARDEN',
  'GEORGE',
  'GODBER',
  'HANKIN',
  'HANSON',
  'HARKER',
  'HARROW',
  'HAYDEN',
  'HOBBEN',
  'HUNTER',
  'KENDAL',
  'LAXTON',
  'burton',
  'daykin',
  'meadows',
  'vedonis',
  'LINNET',
  'LOXLEY',
  'MARION',
  'MEADOW',
  'MERLIN',
  'METEOR',
  'MILTON',
  'MORVEN',
  'MOSLEY',
  'NISSEN',
  'NORMAN',
  'ORCHID',
  'OSPREY',
  'PAGETT',
  'PALMER',
  'PARKER',
  'PRIORY',
  'QUARRY',
  'SABINA',
  'SPRING',
  'SPRUCE',
  'STORTH',
  'SUNRAY',
  'TOTNES',
  'TRUMAN',
  'TURNER',
  'VIOLET',
  'WARREN',
  'WIGHAY',
  'WIGWAM',
  'WILLOW',
  'halfmoon',
  'longhill',
  'redlion',
  'torkard',
]
